<input #input type="text" readonly class="text flex-grow-1" [value]="value" readonly>
<a href="javascript:void(0);" (click)="onCopy()" class="btn btn-primary btn-sm" [class.disabled]="copied">
    <ng-container *ngIf="copied" i18n="@@textCopy.copied">Copied</ng-container>
    <ng-container *ngIf="!copied" i18n="@@textCopy.copy">Copy</ng-container>
</a>
